// Refreshes a page by reloading a TurboFrame, typically after
// an event (eg., mouse click) on a button.
import { Controller } from "@hotwired/stimulus";
import { type TurboFrame } from "@stimulus-library/utilities";

export default class RefresherController extends Controller {
  static targets = ["button"];
  static values = {
    targetId: {
      type: String,
    },
  };
  declare readonly buttonTarget: HTMLAnchorElement;

  declare readonly hasButtonTarget: boolean;

  declare readonly hastargetIdValue: boolean;
  declare targetIdValue: string;

  refresh(event?: Event): void {
    event?.preventDefault();

    const element = document.getElementById(this.targetIdValue) as TurboFrame;
    // @ts-expect-error: claims reload does not exist on TurboFrame
    element.reload();
  }
}
